import { useCallback, useEffect, useState } from 'react';
import { Header } from '../../../common/Header/Header.jsx';
import { Select, SelectPerPage } from '../../../common/Forms/Input/Input';
import {
  DriverLocationTable,
} from '../../../common/Tables/Tables';
import {
  driversLocationTableheader,
} from '../../../../assets/helpers/tables';
import {
  getProvidersEnum,
} from '../../../../assets/helpers/options';
import { providersService } from '../../../../services/providersService.js';
import { notify } from '../../../../assets/helpers/toast';
import { useHistory } from 'react-router-dom';
import { exists, filterParams } from '../../../../assets/helpers/funciones';
import { LocationMapModal } from '../../../common/Modals/Modals';
import './DriversLocation.scss';

const itemsPerpage = [25, 50, 100, 500];

export const DriversLocation = () => {
  const history = useHistory();

  const [fleetLocationsTable, setFleetLocationsTable] = useState({
    limit: itemsPerpage[0],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    type: "",
    isInternal: true,
    isLoading: true,
  });

  const providerTypeOptions = [
    { _id: "", name: "Todos" },
    { _id: getProvidersEnum?.ROAD_ATTENDANT, name: getProvidersEnum?.ROAD_ATTENDANT },
    { _id: getProvidersEnum?.CRANE, name: getProvidersEnum?.CRANE },
  ];


  const [locationModal, setLocationModal] = useState({
    show: false,
  });

  const handleProviderType = (e) => {
    const { value } = e?.target;
    setFleetLocationsTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        type: value,
      };
    });
  };

  const selectitemsPerpage = (event) => {
    setFleetLocationsTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setFleetLocationsTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * fleetLocationsTable?.limit,
      };
    });
  };

  const getDriversLocation = useCallback(() => {
    setFleetLocationsTable((prevState) => {
      return {
        ...prevState, getProvidersUbication: prevState,
        isLoading: true,
      };
    });
    let params = {
      page: fleetLocationsTable?.page,
      limit: fleetLocationsTable?.limit,
      search: fleetLocationsTable?.description,
      isInternal: fleetLocationsTable?.isInternal,
      type: fleetLocationsTable?.type,
    };

    providersService
      .getProvidersUbication(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          setFleetLocationsTable((prevState) => {
            return {
              ...prevState,
              data: response?.data?.providers,
              count: response?.data?.total,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || 'error', 'error');
          setFleetLocationsTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setFleetLocationsTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  }, [
    fleetLocationsTable?.description,
    fleetLocationsTable?.isInternal,
    fleetLocationsTable?.limit,
    fleetLocationsTable?.page,
    fleetLocationsTable?.type,
  ]);

  const handleLocationModal = (data) => {
    setLocationModal((prevState) => {
      return {
        ...prevState,
        show: !prevState.show,
        data: data?.location ? data?.location : "",
      };
    });
  }

  const handleEdit = (e) => {
    history.push(`/providers/external/edit/${e?._id}`);
  };

  useEffect(() => {
    getDriversLocation();
  }, [getDriversLocation]);

  return (
    <>
      <LocationMapModal modal={locationModal} handleModal={handleLocationModal} />
      <Header />
      <div className="service-with-container container">
        <h1 className="title-component">
          Ubicación de Choferes: {exists(fleetLocationsTable?.count)}
        </h1>
        <div className="breadcrumb-container">
          <div className="providers-buttons-container">
            <span></span>
          </div>
        </div>
        <div className="gray-line"></div>

        <div className="filter-button-container"></div>
        <br />
        <div className="breadcrumb-container">
          <span></span>
          <div className="service-filter-buttons-container">
            <Select
              label={"Tipo de proveedor"}
              name={"type"}
              value={fleetLocationsTable?.type}
              options={providerTypeOptions}
              onChange={handleProviderType}
            />
            <SelectPerPage
              label={'Registros por página'}
              options={itemsPerpage}
              value={fleetLocationsTable?.limit}
              onChange={selectitemsPerpage}
            />
          </div>
        </div>
        <DriverLocationTable
          header={driversLocationTableheader}
          dataTable={fleetLocationsTable}
          handlePageChange={handlePageChange}
          edit={handleEdit}
          handleLocationModal={handleLocationModal}
        />
      </div>
    </>
  );
};

